import { CanonicalBusinessEvent } from "../types/cbes";
import { DigitalBusinessDocument } from "../types/documents";

export const getAllProductIds = (
  documents: DigitalBusinessDocument[]
): Set<string> => {
  const allProductIds = new Set<string>();
  documents.forEach((doc) => {
    if (doc?.body?.body?.products) {
      Object.keys(doc.body.body.products).forEach((productId) => {
        allProductIds.add(productId);
      });
    }
  });
  return allProductIds;
};

export const isDocumentBundleTransaction = (
  document?: DigitalBusinessDocument
): boolean => {
  return document?.body?.metadata?.internalAttributes?.IS_BUNDLE === "true";
};

export const isBundleNonSplitTransaction = (
  documents: DigitalBusinessDocument[]
): boolean => {
  if (documents.length === 0) return false;

  const allProductIds = getAllProductIds(documents);

  return isDocumentBundleTransaction(documents[0]) && allProductIds.size === 1;
};

export const groupCbesByProductIds = (
  cbes: CanonicalBusinessEvent[],
  productIds: string[]
): Map<string, CanonicalBusinessEvent[]> => {
  const groups = new Map<string, CanonicalBusinessEvent[]>();

  cbes.forEach((cbe) => {
    const matchedProduct = productIds.find((productId) =>
      cbe.idempotenceId.includes(productId)
    );

    if (!matchedProduct) return;

    if (!groups.has(matchedProduct)) {
      groups.set(matchedProduct, []);
    }
    groups.get(matchedProduct)?.push(cbe);
  });

  groups.forEach((cbeList) => {
    cbeList.sort((a, b) => a.lockVersion - b.lockVersion);
  });

  return groups;
};
